module.exports = __webpack_public_path__ + "img/scrmT1.b0e88632.png";